@if (Visible) {
  <div @addRemove [@.disabled]="!UseAnimation" class="field is-horizontal" ngClass="{{InputPadding == true ? 'mb-2' : ''}}">
    <div class="field-label is-normal">
      <label class="label">{{Label}}@if (Required) {
        <span class="has-text-danger"> *</span>
      }</label>
    </div>
    <div class="field-body">
      <div class="field {{class}}" [ngClass]="{ 'has-addons' : HasAddons == true }">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
}
